import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Text } from '@spark';
import TaskPageTabEmpty from '@/features/tasks/components/TaskPageTabEmpty';
import crunchingIllustration from '@/shared/assets/illustrations/evaluation-crunching.svg';
import '@/features/evaluation/styles/EvaluationTrainingInProgressState.css';

export const TRAINING_IN_PROGRESS_TITLE = 'Crunching the numbers';
export const TRAINING_IN_PROGRESS_BODY =
    'Your model is actively processing. As soon as the evaluation is complete, your statistics, comparisons, and overviews will populate right here.';
export const GO_TO_PROJECTS_LABEL = 'Go to Projects';

/**
 * Evaluations tab state for a task that has no evaluated version yet while a
 * training is still running (Figma 9756-3955): illustration, copy and a
 * "Go to Projects" CTA inside the shared TaskPageTabEmpty chrome.
 */
const EvaluationTrainingInProgressState = () => {
    const navigate = useNavigate();

    return (
        <TaskPageTabEmpty>
            <div className="evaluation-training-in-progress fs-unmask" data-testid="evaluation-training-in-progress">
                <img
                    className="evaluation-training-in-progress__illustration"
                    src={crunchingIllustration}
                    alt=""
                    aria-hidden="true"
                />
                <div className="evaluation-training-in-progress__copy">
                    <Text as="h3" variant="heading-5-semibold" color="primary">
                        {TRAINING_IN_PROGRESS_TITLE}
                    </Text>
                    <Text as="p" variant="base-regular" color="secondary" className="evaluation-training-in-progress__body">
                        {TRAINING_IN_PROGRESS_BODY}
                    </Text>
                </div>
                <Button variant="primary" size="large" onClick={() => navigate('/')}>
                    {GO_TO_PROJECTS_LABEL}
                </Button>
            </div>
        </TaskPageTabEmpty>
    );
};

export default EvaluationTrainingInProgressState;
